import { Component, input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { fullNameValidator } from '../../../../validators/full-name.validators';
import { CustomFormControl } from '../../../../classes/custom-form-control.class';

@Component({
  standalone: true,
  selector: 'mono-common-full-name-input',
  templateUrl: './full-name-input.component.html',
})
export class FullNameInputComponent extends CustomFormControl {

  initialValue = input<string>("");

  constructor() {
    super();
  }

  protected createFormControl(): FormControl {
    return new FormControl(this.initialValue(), [Validators.required, fullNameValidator, Validators.minLength(2), Validators.maxLength(200)]);
  }

}